import Vue from "vue";
import { pushEvent } from "./analytics.mjs";

const priceListComponentDefinition = {
    data : {
        expanded : {},
    },
    methods: {
        isServiceExpanded : function( index ) {
            return !! this.expanded[ index ];
        },
        toggleServiceExpanded : function( event, index, category ) {
            event.preventDefault();
            this.expanded[ index ] = !this.expanded[ index ];

            let name = this.expanded[index] ? 'Category opened' : 'Category closed';
            pushEvent( 'price-list', name, category );

            this.$forceUpdate();
        },
        onTopicClick : function( event, topicId ) {

        },
        onToggleClick : function( event, itemRef, question ) { console.log('hello?');
            if( this.$refs.hasOwnProperty(itemRef) ) {
                this.expanded[ itemRef ] = ! this.getVisibleForIdentifier(itemRef);

                if( this.expanded[ itemRef ] ) {
                    pushEvent( this.$el.id, 'topic open', question );
                }

                this.$forceUpdate();
            }
        },
        getVisibleForIdentifier : function( ident ) {
            return this.expanded.hasOwnProperty( ident )
                && this.expanded[ident] === true
                ;
        }
    }
};

let widgets = document.querySelectorAll('[data-price-list]');
if( widgets && widgets.length ) {
    widgets.forEach( widget => {
        let component = new Vue({
            ...priceListComponentDefinition,
            el: widget
        });

        console.log('price list', component);
    });
}

